const white = "#ffffff";
const black = "#000000";

export default {
  black,
  white,
  current: "currentColor",
  transparent: "transparent",
  primary: "#086BE5",

  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)",
  },

  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)",
  },

  gray: {
    50: "#fafaf9",
    100: "#E3E6EB",
    200: "#ADB6C3",
    300: "#96A3B5",
    400: "#73849D",
    500: "#5A6677",
    600: "#3F4A5A",
    700: "#2F3844",
    800: "#272E38",
    900: "#20252D",
  },

  red: {
    50: "#FFF3F2",
    100: "#FFDAD7",
    200: "#FFC1BC",
    300: "#FEA9A1",
    400: "#FE9087",
    500: "#FE786C",
    600: "#FE5F51",
    700: "#FA1601",
    800: "#A70E01",
    900: "#530700",
  },

  orange: {
    50: "#FFF6F2",
    100: "#FFE9DE",
    200: "#FFD9C5",
    300: "#FFC7A9",
    400: "#FEB389",
    500: "#FEA06C",
    600: "#FE8F51",
    700: "#FE7427",
    800: "#D04B01",
    900: "#7D2D01",
  },

  teal: {
    50: "#F4FDFA",
    100: "#EBFBF5",
    200: "#DAF8ED",
    300: "#B6F1DC",
    400: "#91EACA",
    500: "#48DCA7",
    600: "#28D094",
    700: "#21AD7B",
    800: "#14684A",
    900: "#0D4531",
  },

  cyan: {
    50: "#F5FCFE",
    100: "#E0F5FC",
    200: "#C6EDFA",
    300: "#8EDBF5",
    400: "#68CFF2",
    500: "#42C3EE",
    600: "#1CB7EB",
    700: "#129BC9",
    800: "#0E7CA1",
    900: "#0B5D79",
  },

  blue: {
    50: "#F3F8FF",
    100: "#E9F3FE",
    200: "#BDDAFD",
    300: "#7BB4FA",
    400: "#4F9BF9",
    500: "#2382F7",
    600: "#086BE5",
    700: "#0759BF",
    800: "#054799",
    900: "#043573",
  },
};
